import { ProgramAPI } from '@/api'

export default {
  namespaced: true,
  state: {

  },
  mutations: {
    async onUpdate({ rootGetters, dispatch }) {
      await dispatch('program/steps/setCurrentStep', 'adjusted-values', { root: true });
      // await dispatch('program/steps/setCurrentStepNextFromSelectedStep', 'adjusted-values', { root: true });

      const prog = rootGetters['program/data'];

      dispatch('program/fertigation/destroyState', '', { root: true });
      dispatch('program/blend/destroyState', '', { root: true });
    },
  },
  actions: {

    
  },
  getters: {

    
  }
};
